export default (theme) => ({
  root: {
    margin: 0,
    padding: 10,
    backgroundColor: "#e8e8e8",
  },
  errorText: {
    fontSize: 12,
    color: "#e30613",
  },
  infoText: {
    fontSize: 12,
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: 0,
    color: "#525252",
  },
  panelTitle: {
    fontSize: "1rem",
    fontWeight: "600",
  },
  dialogPaper: {
    minHeight: "600px",
  },
});
